import React from 'react'
import { Input } from 'antd'
import { FastField, Field as FkField } from 'formik' // Field as FkField,
import fieldProps from 'components/platform/form/inputs/fieldProps'
import Select from 'components/platform/form/inputs/Select'
import { FormattedMessage } from 'react-intl'

export const PInput = fieldProps(Input)

const PTextArea = fieldProps(Input.TextArea)

const getDefaultInput = name => {
  switch (name) {
    case 'textarea':
      return PTextArea
    case 'select':
      return Select
    default:
      return PInput
  }
}

export class LayoutField extends React.Component {
  render() {
    const {
      className = '',
      labelClassName = '',
      labelStyle = null,
      parentStyle = null,
      label,
      labelStr,
      obb,
      appendItem,
      children,
      append,
      item,
      labelAppend,
    } = this.props

    const labelfinal = label && label !== '' ? <FormattedMessage id={label} /> : labelStr

    return (
      <div className={`form-group ${className}`} style={parentStyle}>
        {labelfinal && (
          <div className={`fg-label ${labelClassName}`} style={labelStyle}>
            {labelfinal}
            {obb ? <span style={{ color: 'red' }}>*</span> : ''}
            {labelAppend ? <span className={'ml-2'}>{labelAppend}</span> : ''}
            {item ? <span style={{ float: 'right' }}>{item}</span> : ''}
          </div>
        )}
        <div>
          {children}
          {append}
          {appendItem && appendItem()}
        </div>
      </div>
    )
  }
}

export default class Field extends React.Component {
  state = {
    hasError: false,
  }

  render() {
    const {
      name,
      // size = 'sm',
      component = '',
      // layout props
      className = '',
      labelClassName = '',
      labelStyle = null,
      parentStyle = null,
      label,
      labelStr,
      obb,
      item,
      labelAppend,
      appendItem,
      children,
      append,
      dynamic = false,
      componentProps = {},
      //
      ...rest
    } = this.props

    const { hasError } = this.state
    const Component = typeof component === 'string' ? getDefaultInput(component) : component
    if (hasError) {
      // You can render any custom fallback UI
      return <div className="alert alert-danger">Something went wrong. </div>
    }
    if (component === 'textarea' && rest.autoSize === undefined) {
      rest.autoSize = { minRows: 2, maxRows: 5 }
    }
    //  className={``}
    let useDynamicField = dynamic
    // setValues depends of other values so this require a dynamic field
    if (rest.setValues) {
      useDynamicField = true
    }
    const FieldComponent = useDynamicField ? FkField : FastField
    return (
      <LayoutField
        {...{
          className,
          labelClassName,
          labelStyle,
          parentStyle,
          labelStr,
          label,
          obb,
          item,
          labelAppend,
          appendItem,
          children,
          append,
        }}
      >
        <FieldComponent name={name} component={Component} {...rest} {...componentProps} />
      </LayoutField>
    )
  }
}
